const host = {
    production: "http://monthly-service-booking.hk-water.com/cms",
    demoBook: "https://hkws.alphabeans.io",
    local: "http://localhost/hkws-order-cms"
};

export default host.demoBook;
export const production = host.production;
